/*
 * DashboardsPage Messages
 *
 * This contains all the text for the DashboardsPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.features.DashboardsPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'PARAMETA Solutions - Trading Analytics',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Explore Catalogue',
  },
  addAllToCartButton: {
    id: `${scope}.addAllToCartButton`,
    defaultMessage: 'Add All to Cart',
  },
  checkoutButton: {
    id: `${scope}.checkoutButton`,
    defaultMessage: 'Checkout',
  },
  addedAllStatusButton: {
    id: `${scope}.addedAllStatusButton`,
    defaultMessage: 'All Items Added!',
  },
  dataShownDescription: {
    id: `${scope}.dataShownDescription`,
    defaultMessage:
      '{countStart} to {countEnd} shown for {total} data sets selected.',
  },
  failedToFetchProductsError: {
    id: `${scope}.failedToFetchProductsError`,
    defaultMessage:
      'Failed to fetch products. Refresh the page to see if it resolves or contact support.',
  },
  noItems: {
    id: `${scope}.noItems`,
    defaultMessage: 'No products available with your selected filters.',
  },
});
